import { render } from "./PublicTrackingOrderByCustomer.vue?vue&type=template&id=6c3614e1&ts=true"
import script from "./PublicTrackingOrderByCustomer.vue?vue&type=script&lang=ts"
export * from "./PublicTrackingOrderByCustomer.vue?vue&type=script&lang=ts"

import "./PublicTrackingOrderByCustomer.vue?vue&type=style&index=0&id=6c3614e1&lang=css"

import exportComponent from "/home/starkoms/webapps/front-comm-starkoms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__